import * as React from 'react'

import Svg, {
  ClipPath,
  Defs,
  G,
  LinearGradient,
  Path,
  Stop,
} from 'react-native-svg'

const RupeeCircleFilled = (props) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        fill="url(#b)"
        d="M10 1.867a8.134 8.134 0 1 0 0 16.267 8.134 8.134 0 0 0 0-16.267Zm2.667 5.166h-1.809c.4.3.659.725.742 1.2h1.067v.742h-1.059c-.133 1.075-.925 1.675-1.733 1.808l1.808 2.909h-1.5l-1.641-2.767H7.333V9.783h1.7c.592 0 1.042-.308 1.209-.808H7.333v-.742h2.917c-.142-.508-.608-.8-1.225-.8h-1.7V6.292h5.325v.741h.017Z"
      />
    </G>
    <Defs>
      <LinearGradient
        id="b"
        x1={10}
        x2={10}
        y1={1.867}
        y2={18.133}
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#76C686" />
        <Stop offset={1} stopColor="#74A368" />
      </LinearGradient>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h20v20H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)
export default RupeeCircleFilled
